import React from 'react';
import PropTypes from 'prop-types';

import Linkify from 'react-linkify';

const componentDecorator = (href, text, key) => {

  const hrefWrapper = href.includes('@') ? (
    `mailto:${href}`
  ) : (href.startsWith("http://") || href.startsWith("https://")
    ? href
    : `https://${href}`
  )

  return (
    <a href={hrefWrapper} key={key} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  )
};

function matchDecorator(text) {
  const regex = /(https?:\/\/[^\s]+|www\.[^\s]+|\b[^\s]+\.(?:lv|com)\/?)/gi;

  const matches = [];
  let match;

  while ((match = regex.exec(text)) !== null) {
    matches.push({
      schema: '',
      index: match.index,
      lastIndex: match.index + match[0].length,
      text: match[0],
      url: match[0].startsWith('http') ? match[0] : 'http://' + match[0],
    });
  }

  return matches.length > 0 ? matches : null;
}

const LinkifyWithTargetBlank = React.memo(({ children }) => {
  return (
    <Linkify
      componentDecorator={componentDecorator}
      matchDecorator={matchDecorator}
    >
      {children}
    </Linkify>
  );
})

LinkifyWithTargetBlank.propTypes = {
  date: PropTypes.number,
  format: PropTypes.string,
};

LinkifyWithTargetBlank.defaultProps = {
  date: '',
  format: '',
};

export default LinkifyWithTargetBlank;
